module.exports = __webpack_public_path__ + "resources/img/logo_WildStone.a704eeb0b9eec66a6f48cc8960770bb9.png";